<template>
  <div class="ec-day">
    <div v-for="(chunk, key) in appts" :key="key">
      <SlotEvents :chunk="chunk" :resource="resource" />
    </div>
  </div>
</template>

<script setup>
import { watch, ref } from "vue";
import { useDateStore } from "../../stores/datestore";
import SlotEvents from "./SlotEvents.vue";

const props = defineProps({
  resource: {
    type: String,
    required: true,
    default: "",
  },
  appts: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const dateStore = useDateStore();
const _date = ref(new Date());
watch(
  () => dateStore.selectedDate,
  () => {
    _date.value = dateStore.selectedDate;
  },
  { immediate: true }
);
</script>

<style>
.ec-day {
  border-left: 1px solid lightgray;
  width: 100%;
  height: 100%;
}
</style>
